import React, { FC } from 'react';
import { Text, TextProps } from 'react-native';

import { styles, variants } from './styles';
import { Fonts, Varians } from './types';

/**
 * TWCText: A wrapper for Text to set default font to Roboto and allow variations
 * This is the recommended way to set a default font, per https://reactnative.dev/docs/text#limited-style-inheritance
 */
export const TWCText: FC<TWCTextProps> & WithVariants = ({
  accessibilityLabel,
  children,
  fontFamily = 'regular',
  nativeID,
  noTestID,
  style,
  testID,
  variant,
  ...otherProps
}) => {
  const id = nativeID || testID;
  const variantStyle = variant ? variants[variant] : undefined;
  const fontFamilyStyle = fontFamily ? styles[fontFamily] : undefined;

  return (
    <Text
      accessibilityLabel={accessibilityLabel || children?.toString()}
      nativeID={noTestID ? undefined : id}
      style={[fontFamilyStyle, variantStyle, style]}
      testID={testID}
      {...otherProps}
    >
      {children}
    </Text>
  );
};

type TWCTextProps = {
  noTestID?: boolean;
  variant?: Varians;
  fontFamily?: Fonts;
} & TextProps;

type WithVariants = {
  allVariants: typeof variants;
};

TWCText.allVariants = variants;
